import clsx from 'clsx'
import { type ChangeEventHandler, type ForwardedRef, forwardRef } from 'react'

import CheckboxField from './CheckboxField'
import { RadioField } from './RadioField'

export type YesNoInputProps = {
  type: 'radio' | 'checkbox'
  checked?: boolean
  className?: string
  disabled?: boolean
  name: string
  onChange?: ChangeEventHandler<HTMLInputElement>
}

export const YesNoInput = forwardRef(
  (
    { className, disabled, name, checked, onChange, type }: YesNoInputProps,
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    if (type === 'checkbox') {
      return (
        <CheckboxField
          label="Yes"
          ref={ref}
          className={clsx(className)}
          checked={checked}
          onChange={onChange}
          name={name}
          id={name}
          disabled={disabled}
        />
      )
    }
    return (
      <RadioField
        className={className}
        disabled={disabled}
        name={name}
        options={[
          { label: 'Yes', value: 'true' },
          { label: 'No', value: 'false' },
        ]}
        value={checked?.toString() ?? 'false'}
        onChange={e =>
          onChange?.({
            ...e,
            target: {
              ...e.target,
              checked: e.target.value === 'true',
            },
          })
        }
      />
    )
  },
)
